import styled from 'styled-components';

export const SectionsWrap = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  width: 60%;
`;

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  column-gap: 1rem;

  > div:first-child {
    flex: 1;
  }
`;

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const EmptyState = styled.p`
  margin: 0;
  font-weight: 600;
  color: ${({ theme }) => theme.elements.textGrey};
`;

export const SectionHint = styled.p`
  margin: 0 0 1rem 0;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-size: ${({ theme }) => theme.fontSizes.small};
`;

export const TableWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;

  table {
    width: 100%;
    table-layout: inherit;
  }
`;

export const ActionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const CheckboxWrapper = styled.div<{ $isDisabled: boolean }>`
  display: flex;
  justify-content: center;
  opacity: ${({ $isDisabled }) => ($isDisabled ? 0.4 : 1)};
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'not-allowed' : 'pointer')};
  pointer-events: ${({ $isDisabled }) => ($isDisabled ? 'none' : 'auto')};
`;

export const ButtonWrapper = styled.div`
  display: flex;
`;

export const AddressContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
`;

export const SectionWithAction = styled.div`
  background-color: ${({ theme }) => theme.colors.defaultWhite};
  border: 1px solid ${({ theme }) => theme.elements.primaryLight};
  padding: 16px;
  border-radius: 14px;
`;

export const SectionHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const SectionHeadingText = styled.h3`
  font-size: ${({ theme }) => theme.elementFontSizes.subSectionTitle};
  color: ${({ theme }) => theme.elements.submissionHeading};
  margin: 0;
`;

export const UploadButton = styled.button`
  background-color: #ffffff;
  border: 1px solid #003399;
  color: #003399;
  padding: 6px 14px;
  border-radius: 12px;
  font-weight: 500;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;

  &:hover:not(:disabled) {
    background-color: #f0f6ff;
    border-color: #002266;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
